'use strict';

var $ = window.$;
var mediaXxs = 320;
var mediaXs = 480;
var mediaSm = 768;
var mediaMd = 1024;
var mediaLg = 1280;
var mediaXl = 1400;
var mediaXxl = 1600;

function pageFullHeight() {
  var $header = $('.page__header');
  var $main = $('.page__main');
  var $footer = $('.page__footer');
  var viewportHeight = $(window).height();
  var pageHeight = $header.outerHeight() + $main.outerHeight() + $footer.outerHeight();
  var heightNeedToCompensate = viewportHeight - pageHeight;

  if (heightNeedToCompensate > 0) {
    $footer.css('margin-top', heightNeedToCompensate + 'px');
  }
}

function sliderAlignFix($slider) {
  var slickTrack = $slider.find('.slick-track');
  slickTrack.css('height', 'auto');
  var sliderHeight = slickTrack.height();
  slickTrack.css('height', sliderHeight + 'px');
}

$(function () {
  $.fancybox.defaults.touch = false;
  $.fancybox.defaults.closeExisting = true;
  pageFullHeight(); 

  var scrollWidth = window.innerWidth - document.documentElement.clientWidth;

  if (scrollWidth > 0) {
    $('<style type="text/css">').html('.scrollbar-compensate { margin-right: ' + scrollWidth + 'px; }').appendTo('head');
  }

  window.initNiceScroll = function (selector) {
    var $block = selector instanceof jQuery ? selector : $(selector);
    $block.niceScroll({
      cursorwidth: 3,
      cursorborderradius: '72px',
      cursorcolor: '#D8D8D8',
      cursorborder: 'none',
      autohidemode: 'leave'
    });
  };

  window.initNiceScroll(".has-scrollbar");
  $(document).on('click', '[js-input-counter] [class*="__minus"]', function () {
    var $block = $(this).closest('[js-input-counter]');
    var $input = $block.find('[class*="__input"]');
    var number = $input.val();
    if (number > 1) number--;
    $input.val(number);
  });
  $(document).on('click', '[js-input-counter] [class*="__plus"]', function () {
    var $block = $(this).closest('[js-input-counter]');
    var $input = $block.find('[class*="__input"]');
    var number = $input.val();
    number++;
    $input.val(number);
  });
  $('[js-input-interval]').each(function () {
    var $block = $(this);
    var $init = $block.find('[class*="__input-init"]');
    var $valueFrom = $block.find('[class*="__value-from"]');
    var $valueTo = $block.find('[class*="__value-to"]');
    $init.ionRangeSlider({
      type: "double",
      hide_min_max: true
    }).on('change', function (data) {
      $valueFrom.text($(this).data('from'));
      $valueTo.text($(this).data('to'));
    });
  });
  $('[js-slider-menu]').each(function () {
    var $block = $(this);
    var $arrows = $block.find('[class*="__arrows"]');
    var $init = $block.find('[class*="__init"]');
    var $link = $block.find('[class*="__link"]');
    $init.slick({
      appendArrows: $arrows,
      variableWidth: true,
      infinite: true
    });
    $($link).hover(function () {
      var id = $(this).attr('data-show-submenu');
      $block.find('[data-submenu="' + id + '"]').addClass('open');
    }, function () {
      var id = $(this).attr('data-show-submenu');
      $block.find('[data-submenu="' + id + '"]').removeClass('open');
    });
  });
  $('[js-banner-slider]').each(function () {
    var $block = $(this);
    var $prevArrow = $block.find('.slick-prev');
    var $nextArrow = $block.find('.slick-next');
    var $dots = $block.find('[class*="__slick-dots"]');
    var $init = $block.find('[class*="__init"]');
    $init.slick({
      dots: true,
      infinite: true,
      appendDots: $dots,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow
    });
  });
  $(document).on('click', ' [js-menu-stages] [class*="__btn-toggle"]', function () {
    var $block = $(this).closest('[js-menu-stages]');
    var $item = $block.find('[class*="__item"]');
    var $itemThis = $(this).closest($item);
    var $itemParents = $(this).parents($item);
    $item.not($itemParents).removeClass('open');
    $itemThis.toggleClass('open');
  });
  $(document).on('click', '[js-toggle-open]', function () {
    $(this).toggleClass('open');
  });
  $(document).on('click', '[js-brand-category-card] [class*="__toggle-link"]', function () {
    var $block = $(this).closest('[js-brand-category-card]');
    $block.addClass('open');
  });
  $('[js-search-results] [class*="__input"]').focusin(function () {
    $(this).addClass('focus');
  }).focusout(function () {
    $(this).removeClass('focus');
  });
  $(document).on('click', '[js-search-btn]', function () {
    if ($(window).width() >= mediaSm) {
      $(this).parent().prev('[class*="__search"]').submit();
    } else {
      $(this).parent().prev('[class*="__search"]').toggleClass('open');
    }
  });
});
$(function () {
  var $window = $('.page__mobile-window');
  var $overlay = $('.page__overlay');
  $(document).on('click', '[js-mobile-window-open]', function () {
    if ($(window).width() < mediaLg) {
      var id = $(this).attr('js-mobile-window-open');
      $(id).addClass('open');
      $overlay.addClass('active');
      return false;
    }
  });
  $(document).on('click', '[js-mobile-window-close]', function () {
    if ($(window).width() < mediaLg) {
      $window.removeClass('open');
      $overlay.removeClass('active');
    }
  });
  $(document).on('click', '.page__overlay', function () {
    if ($(window).width() < mediaLg) {
      $window.removeClass('open');
      $overlay.removeClass('active');
    }
  });
  $(document).on('click', '[js-product-cart] [class*="__delete-btn"]', function () {
    $(this).closest('[js-product-cart]').remove();
  });
});
$('[js-slider-main]').each(function () {
  var $block = $(this);
  var $init = $block.find('[class*="__init"]');
  var $slide = $block.find('[class*="__slide"]');
  var $prevArrow = $block.find('.slick-prev');
  var $nextArrow = $block.find('.slick-next');
  var $dots = $block.find('.slider-dots');
  var hackClass = 'zindex-hack';

  function unslick() {
    if ($init.hasClass('slick-slider')) {
      $init.slick('unslick');
    }
  }

  if ($block.hasClass('slider-main_type_logo')) {
    $(window).on('load resize', function () {
      var width = $(window).width();

      if (width < mediaSm) {
        unslick();
      } else {
        unslick();
        $init.slick({
          dots: true,
          appendDots: $dots,
          prevArrow: $prevArrow,
          nextArrow: $nextArrow,
          variableWidth: true
        });
      }
    });
  } else if ($block.hasClass('slider-main_type_catalog')) {
    $init.slick({
      mobileFirst: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      variableWidth: true,
      responsive: [{
        breakpoint: mediaMd,
        settings: {
          variableWidth: false,
          slidesToShow: 3
        }
      }]
    });
  } else {
    $init.slick({
      dots: true,
      appendDots: $dots,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      variableWidth: true
    });
  }

  $(window).on('load resize', function () {
    sliderAlignFix($init);
  });
  $slide.hover(function () {
    $(this).closest($block).addClass(hackClass);
  }, function () {
    $(this).closest($block).removeClass(hackClass);
  });
});
$(function () {
  var $block = $('[js-switch-view]');
  var $btnViewList = $block.find('.btn-view-list');
  var $grid = $block.find('.grid-categories');
  var $card = $block.find('.product-card');
  $(document).on('click', '[js-switch-view] .btn-view_icon_rows', function () {
    $btnViewList.find('.btn-view').removeClass('active');
    $(this).addClass('active');
    $grid.addClass('grid-categories_view_rows');
    $card.addClass('product-card_view_rows');
  });
  $(document).on('click', '[js-switch-view] .btn-view_icon_tiles', function () {
    $btnViewList.find('.btn-view').removeClass('active');
    $(this).addClass('active');
    $grid.removeClass('grid-categories_view_rows');
    $card.removeClass('product-card_view_rows');
  });
});
$(window).on('load', function () {
  pageFullHeight();
});
$(window).on('resize', function () {
  pageFullHeight();
});